import { render, staticRenderFns } from "./CampaignBox.vue?vue&type=template&id=7f4f29b8&scoped=true&"
import script from "./CampaignBox.vue?vue&type=script&lang=js&"
export * from "./CampaignBox.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBox.vue?vue&type=style&index=0&id=7f4f29b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4f29b8",
  null
  
)

export default component.exports